import BaseService from "@/services/BaseService";
// import jwtManager from "@/store/jwt";

class AccountService extends BaseService {

    getPersonIdentity() {
        let settings = {
            baseURL: `${this.baseUrl}/customer-management`,
            method: "GET"
        };
        console.log("getPersonIdentity");
        return this.service(settings);
    }
    putPersonIdentity(data) {
        let settings = {
            baseURL: `${this.baseUrl}/customer-management`,
            method: "PUT",
            data: data
        };
        console.log("putPersonIdentity");
        return this.service(settings);
    }
}

export default AccountService;